import React, { useEffect, useState } from 'react';
import {
  Home as HomeOutlined,
} from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { Gradient } from '../AdminHeader/Gradient.js';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/index';

const gradient = new Gradient();

const SUPPORT_EMAIL = 'support@headshotsnow.ai';

const DeliveryPolicy = () => {
  const [currentLanguage, setCurrentLanguage] = useState('');

  const { t } = useTranslation();

  useEffect(() => {
    gradient.initGradient('#canvas-gradient');
    window.scrollTo(0, 0);
    return () => { };
  }, []);

  useEffect(() => {
    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  const homeHref = currentLanguage === 'en' ? '/' : `/${currentLanguage}/`;

  return (
    <>
      <main style={{ background: '#000' }}>
        <div className="landing-cover" data-controller="gradient-animation">
          <div className="container">
            <div className="d-flex flex-column align-items-center">
              <h1 className="display-1 fw-semi-bold text-white text-center mb-5 mb-sm-4">Delivery &amp; Fulfillment Policy</h1>
              <Link to={homeHref} className="btn btn-soft-light btn-sm rounded-pill tag text-nowrap">
                <HomeOutlined />
                {t('button.backHome')}
              </Link>
            </div>
          </div>
          <canvas id="canvas-gradient" data-transition-in />
          <div id="canvas-overlay" />
        </div>
      </main>
      <section className="bg-white text-black">
        <div className="container mx-auto p-6 max-w-4xl">
          <p className="mb-4">
            HeadshotsNow.ai sells a <span className="font-semibold">digital product</span>: AI-generated professional
            headshots. This policy explains how and when your order is delivered.
          </p>

          <h2 className="text-2xl font-bold mb-2">1. Digital Product — No Shipping</h2>
          <p className="mb-4">
            There is nothing to ship. You will not be charged any shipping fees, and no physical item is sent. All
            results are delivered electronically.
          </p>

          <h2 className="text-2xl font-bold mb-2">2. How You Receive Your Headshots</h2>
          <p className="mb-4">
            After your photos are processed, your finished headshots appear in your secure online dashboard, where you can
            preview and download them. Where applicable, we may also notify you by email when your headshots are ready.
          </p>

          <h2 className="text-2xl font-bold mb-2">3. Estimated Turnaround</h2>
          <ul className="list-disc list-inside mb-4" style={{ paddingLeft: '1.5em' }}>
            <li>Most headshot packages are ready within approximately <span className="font-semibold">1–2 hours</span> of completing your upload and checkout.</li>
            <li>Turnaround can vary with order size and current demand. The estimate for each package is shown on the pricing section.</li>
            <li>Because results are AI-generated, exact timing and visual results may vary.</li>
          </ul>

          <h2 className="text-2xl font-bold mb-2">4. Results May Vary With Photo Quality</h2>
          <p className="mb-4">
            The quality of your headshots depends on the photos you upload. Clear, well-lit photos with a variety of
            angles and expressions produce the best results. See our upload guidelines for tips.
          </p>

          <h2 className="text-2xl font-bold mb-2">5. If Generation Fails</h2>
          <p className="mb-4">
            If a generation fails or you do not receive a usable headshot, we will re-run your generation at no additional
            cost in most cases. If we still cannot deliver a usable result, you may be eligible for a refund under our{' '}
            <Link to="/refund" className="underline">Refund Policy</Link>.
          </p>

          <h2 className="text-2xl font-bold mb-2">6. Support</h2>
          <p className="mb-4">
            Haven&rsquo;t received your headshots or need help? Contact {SUPPORT_EMAIL} and we&rsquo;ll respond within 1
            business day.
          </p>

          <p className="mb-4 font-bold">Last updated: 18 June 2026</p>
        </div>
      </section>
    </>
  );
};

export default DeliveryPolicy;
